import React from 'react';
import BladesDashboard from 'src/blades/blades.dashboard';
const Dashboard = () => {
    return (
        <BladesDashboard />
    )
}
export default Dashboard;